module.exports = __webpack_public_path__ + "img/blend1icon1.ae273e2d.png";